
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./ActiveRentals.css'],
  selector: 'ActiveRentals',
  templateUrl: './ActiveRentals.component.html',
})
export class ActiveRentalsComponent extends PageBase {
    constructor(el: ElementRef) {
      super(el, "ActiveRentals");
    }
}
